import { Browser } from '@capacitor/browser'
import type { User } from 'firebase/auth'
import type { AuthUser } from '../../context/authContextCore'
import { Button, DangerActionRow } from '../Common'

type MemberAccountPanelProps = {
  user: AuthUser | User | null
  onSignOut: () => void
}

const openSupport = async () => {
  const url = 'https://timelining.app/support'
  try {
    await Browser.open({ url })
  } catch {
    if (typeof window !== 'undefined') window.open(url, '_blank', 'noopener,noreferrer')
  }
}

/** A deliberately narrow Member account surface; desktop profile editing remains in ProfilePanel. */
export const MemberAccountPanel = ({ user, onSignOut }: MemberAccountPanelProps) => (
  <div className="settingsFormGrid">
    <article className="settingsCacheBlock settingsWideField">
      <strong>Signed-in account</strong>
      <p>{user?.email ?? 'Your account details are available after sign-in.'}</p>
    </article>
    <DangerActionRow
      dangerZone
      title="Account actions"
      description="Sign out of this device, or get help with account changes."
      actions={[
        { key: 'sign-out', label: 'Sign out', variant: 'secondary', onClick: onSignOut },
        // Follow-up plan: Account deletion pipeline (Auth, retention, audit, confirmation, and subscriptions).
        { key: 'delete-account', label: 'Coming soon — contact support', variant: 'secondary', disabled: true, onClick: () => void openSupport() },
      ]}
    />
    <Button variant="tertiary" size="sm" onClick={() => void openSupport()}>Help & support</Button>
  </div>
)
